export const yAxisUnit = {
  DISPLAYS_BY_DAY: "number",
  USAGES_BY_DAY: "number",
  CLOSURES_BY_DAY: "number",
  PERCENT_USAGES_BY_DAY: "percent",
  PERCENT_CLOSURES_BY_DAY: "percent",
};
